<template>
  <div class="left-side" v-if="relatedCompanies.length">
    <div class="page-header">
      <h1 class="m-n text-u-c title-font">Related Companies</h1>
    </div>
    <div
      class="row p-b-md"
      v-for="(profile, index) of relatedCompanies"
      :key="index"
    >
      <div
        class="col-lg-12 b-light profile-block p-x-n"
        @click="goOwner(profile.id)"
      >
        <span class="pull-left thumb m-r-sm">
          <lazy-img-loader
            :mainImg="getCompanyImage(profile.profile)"
            :imgAlt="profile.name"
          ></lazy-img-loader>
          <i class="on b-white bottom"></i>
        </span>
        <div class="profile-content">
          <div class="profile-name text-ellipsis">{{ profile.name }}</div>
          <div class="profile-ago text-ellipsis">
            {{ getAgo(profile.profile.updated_at) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImgLoader from '@src/components/lazy-img-loader'
import moment from 'moment-timezone'

export default {
  components: { LazyImgLoader },
  data() {
    return {
      loader: false,
    }
  },
  computed: {
    relatedCompanies() {
      return this.$store.getters.relatedCompanies ? this.$store.getters.relatedCompanies : []
    },
  },
  created() {
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1 month',
        MM: '%d months',
        y: '1 year',
        yy: '%d years',
      },
    })
  },
  methods: {
    getCompanyImage(profile) {
      return typeof profile.thumbs['thumb-lg'] !== 'undefined'
        ? profile.thumbs['thumb-lg']
        : profile.avatar
    },
    getAgo(time) {
      return moment.unix(time).fromNow()
    },
    goOwner(id) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/default/corporate#/view/${id}/about`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.image-rounded {
  border-radius: 100%;
  overflow: hidden;
  margin-right: 10px;
}
.profile-block {
  cursor: pointer;
}
.profile-content {
  padding-top: 7px;
}
@media only screen and (min-width: 1200px) {
  .left-side .page-header {
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000;
  }
  .profile-name {
    font-weight: 300;
    font-size: 17px;
    line-height: 17px;
    color: #000;
  }
  .profile-ago {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #888;
  }
  .page-header {
    margin: 0px;
  }
  .row {
    margin: 0px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
  .left-side .page-header {
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    color: #000;
  }
  .profile-name {
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    color: #000;
  }
  .profile-ago {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #888;
  }
  .page-header {
    margin: 0px;
  }
  .row {
    margin: 0px;
  }
}
@media only screen and (max-width: 767px) {
  .left-side {
    padding-left: 20px;
  }
  .left-side .page-header {
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    color: #000;
  }
  .profile-name {
    font-weight: 300;
    font-size: 17px;
    line-height: 20px;
    color: #000;
  }
  .profile-ago {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #888;
  }
  .page-header {
    margin: 0px;
  }
  .row {
    margin: 0px;
  }
}
</style>
